import React from 'react';

import './poweredByPushpay.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { PushpayLogo } from '../../assets/svg/PushpayLogo';

type PoweredByPushpayProps = {
	className?: string;
};

export function PoweredByPushpay({ className }: PoweredByPushpayProps) {
	const { t } = useTranslation();

	return (
		<div className={clsx('container', className)}>
			{t('poweredBy')}:
			<PushpayLogo className="pushpayLogo" width="70" />
		</div>
	);
}
